const complementFileUrl = (url?: string | null): string | undefined => {
  if (url && url.startsWith('/')) {
    url = url.substr(1);
  }
  return url ? (url.startsWith('http') ? '' : window.DataModel.__env.BaseURL) + url : undefined;
};

export default complementFileUrl;
